/** One recipient of a sent email (drill-down row). Maps EmailMessageRecipientResource (PascalCase). */
export default class EmailRecipientItem {
  id: number

  institutionId?: number

  institutionName: string

  recipientEmail: string

  statusId: number // EmailRecipientStatusEnum: 1=pending, 2=sent, 3=failed

  attempts: number

  sentAt?: Date

  errorMessage: string

  constructor(r: any) {
    this.id = r.Id
    this.institutionId = r.InstitutionId
    this.institutionName = r.InstitutionName
    this.recipientEmail = r.RecipientEmail
    this.statusId = r.StatusId
    this.attempts = r.Attempts
    this.sentAt = r.SentAt ? new Date(r.SentAt) : undefined
    this.errorMessage = r.ErrorMessage || ''
  }
}
